import { useDispatch } from 'react-redux';

import { open as openChat } from '@r1-frontend/entities/Chat/store/actions';

import { Link } from './styled';

interface IProps {
    children?: JSX.Element | JSX.Element[] | string,
    clickHandle?: () => void,
}

const OpenChat = ({ children = 'чат', clickHandle }: IProps): JSX.Element => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(openChat());
        if (typeof clickHandle === 'function') {
            clickHandle();
        }
    };

    return (
        <Link onClick={onClick}>{children}</Link>
    );
};

export default OpenChat;
